import { render, staticRenderFns } from "./UserEmail.vue?vue&type=template&id=c1a6cf90&scoped=true&"
import script from "./UserEmail.vue?vue&type=script&lang=js&"
export * from "./UserEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a6cf90",
  null
  
)

export default component.exports